import axios from 'axios';
export const dispatchClient = axios.create();
export const dispatchClient_WUS = axios.create({
  baseURL: 'https://api-wus.ngsapps.net',
});
export const dispatchClient_EUS = axios.create({
  baseURL: 'https://api-eus.ngsapps.net',
});
